export default __webpack_public_path__ + "static/media/akka.e4c67dfd.svg";